module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAJxJREFUSEtj/PTj/38GGgLGUQsIhe5oEBEKIYbRICItiL58+cJw+9YtBlU1NQYeHh4Mzbdv3waLqaqqYsjh0osSB6tXrmD48uUTAw8PH0NoeASKISDDjxzaDxazsXPEsASXXqItuHP7NsNhqAW2dg4MKqpqKA4gygJCQQSyhIHhP4bhIJuICiKCMUaGgtF8QDDQRoNoNIgIhgBBBQAtiKDZ8xvmwQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_more.png
// module id = mYqV
// module chunks = 61